import { createFileRoute } from '@tanstack/react-router';
import { PortfolioHome } from '../pages/PortfolioHome';

export const Route = createFileRoute('/')({
  component: PortfolioHome,
});
